// ReadyDocs Method of Payment values. Automatic Payment is ACH. Statement Billing is Statement.
export const METHOD_OF_PAYMENT_ACH = 'ACH';
export const METHOD_OF_PAYMENT_STATEMENT = 'Statement';

/**
 * Maps the Automatic Payment checkbox to the ReadyDocs MethodOfPayment value.
 *
 * @param {boolean} isAutoPay - true when the lessee left Automatic Payment checked
 * @returns {string} 'ACH' or 'Statement'
 */
export const toMethodOfPayment = (isAutoPay) =>
  isAutoPay ? METHOD_OF_PAYMENT_ACH : METHOD_OF_PAYMENT_STATEMENT;

/**
 * Builds the body for POST applications/{n}/document-sign.
 *
 * @param {object} args
 * @param {string} args.processingFeeOption - 'lessee' or 'dealer'
 * @param {number} args.paymentProfileId - the Payix payment method id selected for signing
 * @param {boolean} args.isAutoPay - the Automatic Payment checkbox state
 * @param {string} [args.returnUrl] - sent as EmbeddedSigningReturnUrl only when present
 * @returns {object} the request body
 */
export const buildDocumentSignPayload = ({ processingFeeOption, paymentProfileId, isAutoPay, returnUrl }) => {
  const payload = {
    ProcessingFeeBy: processingFeeOption,
    PaymentProfileId: paymentProfileId,
    MethodOfPayment: toMethodOfPayment(isAutoPay),
  };

  if (returnUrl) {
    payload.EmbeddedSigningReturnUrl = returnUrl;
  }

  return payload;
};
